import { useGetMediaPromptSuggestionsMutation } from "@/shared/services";
import { useCallback } from "react";
import { useAiImageStore } from "../store";
import { getActiveSlideContent } from "../utils";

export const useGetSuggestions = () => {
  const type = useAiImageStore((s) => s.type);
  const {
    mutate: getSuggestions,
    isPending,
    isError,
    data,
  } = useGetMediaPromptSuggestionsMutation();

  const handleGetSuggestions = useCallback(async () => {
    try {
      const content = getActiveSlideContent() ?? "";
      getSuggestions({
        content,
        type,
      });
    } catch (error) {
      console.error(error);
    }
  }, [getSuggestions, type]);

  return {
    handleGetSuggestions,
    isPending,
    isError,
    data: data?.suggestions,
    type,
  };
};
